import { authWSClient } from 'WSClient';
import {
  ADD_ANALYTICS_MESSAGES,
  SET_MESSAGE_AS_READ,
  SET_ALL,
} from './mutation-types';
import initialState from './state';

export default {
  resetAnalytics({ commit }) {
    commit(SET_ALL, initialState());
  },
  setupNotification({ dispatch }) {
    authWSClient.subscribe(
      'analytic',
      { numMessagesFromArchive: 50 },
      message => dispatch('handleNotification', message),
    );
  },
  handleNotification({ commit }, messages) {
    commit(ADD_ANALYTICS_MESSAGES, messages);
  },
  setMessageAsRead({ commit }, messageId) {
    if (!messageId) return;
    // Send to server
    authWSClient.setMessageAsRead(messageId);
    // Change in store
    commit(SET_MESSAGE_AS_READ, messageId);
  },
};
